import React, { useState, useEffect } from "react";

export const ModalCustom = ({ isVisible, children, size, onClose }) => {
  const [isize, setIsize] = useState("540px");

  useEffect(() => {
    switch (size) {
      case "xsm": setIsize("350px"); break;
      case "sm": setIsize("440px"); break;
      case "m": setIsize("720px"); break;
      case "l": setIsize("860px"); break;
      case "lg": setIsize("960px"); break;
      case "xl": setIsize("1140px"); break;
      case "xxl": setIsize("1320px"); break;
      default: setIsize("540px"); break;
    }
  }, [size]);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center p-4 sm:p-6">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-gray-900/60 backdrop-blur-sm transition-opacity"
        onClick={() => onClose(!isVisible)}
      />
      
      {/* Modal Content */}
      <div 
        className="relative flex flex-col bg-white rounded-2xl shadow-2xl w-full max-h-[95vh] overflow-hidden animate-scale-up"
        style={{ maxWidth: isize }}
      >
        <button
          className="absolute top-4 right-4 z-10 p-2 text-gray-400 hover:text-gray-700 bg-white hover:bg-gray-100 rounded-full transition-colors focus:outline-none"
          onClick={() => onClose(!isVisible)}
          title="Cerrar"
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        
        <div className="overflow-y-auto overflow-x-hidden w-full h-full custom-scrollbar">
          {children}
        </div>
      </div>
    </div>
  );
};
